module.exports = __webpack_public_path__ + "img/idcard.bd788c88.png";